const CropIcon = () => {
	return (
		<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M3.125 0.625V8.95833C3.125 9.17935 3.2128 9.39131 3.36908 9.54759C3.52536 9.70387 3.73732 9.79167 3.95833 9.79167H12.2917M0.625 3.125H8.95833C9.17935 3.125 9.39131 3.2128 9.54759 3.36908C9.70387 3.52536 9.79167 3.73732 9.79167 3.95833V12.2917"
				stroke="var(--secondary-color)"
				strokeOpacity="0.85"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default CropIcon;
